import { useContext } from "react";
import { AuthCtx } from "./AuthCtx";

export function useAuthCtx() {
  return useContext(AuthCtx);
}
